import Skeleton from "@mui/material/Skeleton";

import { Box, Card, CardContent, Paper } from "@mui/material";

import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";

import { config, styles } from "../../style";

import Grid from "@mui/material/Unstable_Grid2";
import CustomiseTable from "../../components/CustomiseTable";

const type = "proposal";

export const skeletonHeader = (
    <Box>
        <Paper sx={{ p: "20px", display: "flex", flexDirection: "column" }} elevation={3}>
            <Box sx={{ fontSize: "12px", color: "gray" }}>Proposals for</Box>
            <Box
                sx={{
                    textTransform: "uppercase",
                    fontWeight: "800",
                    fontSize: "21px",
                    mt: "10px",
                    width: "300px",
                    "@media (max-width:375px)": {
                        width: "100%",
                    },
                }}
            >
                <Skeleton variant="rounded" width={'100%'} height={30} />
            </Box>
        </Paper>
    </Box>
);
export const skeletonButton = (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
        }}
    >
        <Box
            mb={"20px"}
            marginRight={"1rem"}
            sx={{
                width: "300px",
                "@media (max-width:375px)": {
                    width: "100%",
                },
            }}
        >
            <Skeleton variant="rounded" width={"100%"} height={30} />
        </Box>
        <Box
            display={"flex"}
            alignItems={"center"}
            mb={"20px"}
            sx={{
                width: "300px",
                "@media (max-width:375px)": {
                    width: "100%",
                },
            }}
        >
            <Skeleton variant="rounded" width={80} height={30} sx={{ marginRight: "1rem" }} />
            <Skeleton variant="rounded" width={200} height={30} />
        </Box>
    </Box>
);
export const skeletonTableUI = (
    <CustomiseTable
        columns={Array.from({ length: 6 })}
        rows={Array.from({ length: 10 })}
        showSkeleton={true}
        componentStyleProps={{
            tableContainerSx: {
                marginLeft: "-20px",
                width: "calc(100% + 40px)",
                boxShadow: "unset",
                borderRadius: "unset",
            },
            tableHeadSx: {
                "&.MuiTableHead-root .MuiTableCell-root": {
                    fontSize: "14px",
                    lineHeight: "18px",
                    fontWeight: 400,
                    color: "#000",
                    textTransform: "inherit",
                    background: "#FCFCFD",
                },
            },
            tableHeaderCellSx: {
                background: "#FCFCFD",

                color: "red",

                ".MuiTableHead-root &": {
                    borderTop: "1px solid #EAECF0",
                    borderBottom: "1px solid #EAECF0",
                },
            },
            tableBodySx: {
                "&.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
                    borderBottom: "1px solid #EAECF0",
                },
                "&.MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root": {
                    borderBottom: "none",
                },

                "&.MuiTableBody-root .MuiTableCell-root": {
                    cursor: "pointer",
                },
            },
        }}
    />
);
export const skeletonCardUI = (
    <Grid container spacing={3} alignItems="stretch">
        {Array.from(Array(10).keys()).map((item) => (
            <Grid item key={item} lg={4} md={4} xs={12}>
                <Card
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        border: "1px solid #E9E9E9",
                        minHeight: "200px",
                    }}
                >
                    <CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
                        <Box
                            sx={{
                                p: "10px",
                                background: styles.card.cardHeaderColor,
                                display: "flex",
                                flexDirection: "row",
                                color: "#ffffff",
                                alignItems: "center",
                            }}
                        >
                            {type === "proposal" && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        color: "#ffffff",
                                        alignItems: "center",
                                    }}
                                >
                                    <HistoryEduIcon fontSize="small" sx={{ mr: "10px" }}></HistoryEduIcon> Proposal
                                </Box>
                            )}
                            {type === "event" && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        color: "#ffffff",
                                        alignItems: "center",
                                    }}
                                >
                                    <LocalActivityIcon fontSize="small" sx={{ mr: "10px" }}></LocalActivityIcon> Event
                                </Box>
                            )}
                        </Box>
                        <Box sx={{ p: "10px" }}>
                            <Skeleton variant="rounded" width={200} height={20} />
                            <Grid sx={{ my: "5px", pl: "0px" }} container wrap="wrap" spacing={0} justifyContent="start" direction="row">
                                <Grid item>
                                    <Skeleton variant="rounded" width={100} height={10} />
                                </Grid>
                                <Grid sx={{ ml: "1rem" }} item>
                                    <Skeleton variant="rounded" width={100} height={10} />
                                </Grid>
                            </Grid>
                            <Grid sx={{ pl: "0px" }}>
                                <Skeleton variant="rounded" width={100} height={25} />
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        ))}
    </Grid>
);
export const skeletonCard = (
    <div>
        {skeletonHeader}
        <Box sx={{ marginTop: "1rem", mb: "20px" }}>
            <Paper sx={{ p: "20px" }} elevation={3}>
                {skeletonButton}
                {skeletonCardUI}
            </Paper>
        </Box>
    </div>
);

export const skeletonTable = (
    <div>
        {skeletonHeader}

        <Box sx={{ marginTop: "1rem", mb: "20px" }}>
            <Paper sx={{ p: "20px" }} elevation={3}>
                {skeletonButton}
                {skeletonTableUI}
            </Paper>
        </Box>
    </div>
);
